import {
  buildAuthUser,
  clearSession,
  getCurrentUserRecord,
  getDatabase,
  sanitizeUser,
  setSession,
  updateDatabase
} from '../data/localDataStore';

export const authService = {
  async signIn(username, password) {
    try {
      const database = getDatabase();
      const user = database.users.find(
        (item) => item.username === username && item.password === password
      );

      if (!user) {
        return {
          success: false,
          error: 'Nome utente o password non validi'
        };
      }

      if (!user.is_active) {
        return {
          success: false,
          error: 'Utente disattivato. Contatta un amministratore.'
        };
      }

      updateDatabase((draft) => {
        const targetUser = draft.users.find((item) => item.id === user.id);
        if (targetUser) {
          targetUser.last_login_at = new Date().toISOString();
          targetUser.updated_at = new Date().toISOString();
        }
      });

      setSession(user.id);

      return {
        success: true,
        data: {
          session: {
            user: buildAuthUser(user)
          }
        }
      };
    } catch (error) {
      return {
        success: false,
        error: 'Errore imprevisto durante l\'accesso'
      };
    }
  },

  async signOut() {
    try {
      clearSession();
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: 'Errore durante la disconnessione'
      };
    }
  },

  async getCurrentSession() {
    try {
      const currentUser = getCurrentUserRecord();
      if (!currentUser) {
        return { success: true, session: null };
      }

      return {
        success: true,
        session: {
          user: buildAuthUser(currentUser)
        }
      };
    } catch (error) {
      return { success: false, error: 'Errore nel recuperare la sessione' };
    }
  },

  async getUserProfile(userId) {
    try {
      const database = getDatabase();
      const profile = database.users.find((user) => user.id === userId) || null;
      return { success: true, profile: sanitizeUser(profile) };
    } catch (error) {
      return { success: false, error: 'Errore nel recuperare il profilo utente' };
    }
  },

  async updateUserProfile(userId, updates) {
    try {
      let updatedProfile = null;

      updateDatabase((draft) => {
        const targetUser = draft.users.find((user) => user.id === userId);
        if (!targetUser) {
          return;
        }

        Object.assign(targetUser, updates, {
          updated_at: new Date().toISOString()
        });

        updatedProfile = sanitizeUser(targetUser);
      });

      if (!updatedProfile) {
        return { success: false, error: 'Profilo utente non trovato' };
      }

      return { success: true, data: updatedProfile };
    } catch (error) {
      return { success: false, error: 'Errore nell\'aggiornamento del profilo utente' };
    }
  }
};

export default authService;
